import { BACKEND_URI } from "../entries";

export const sendMessage = async ({
  socket,
  message,
  ticketInfo,
  user,
  replyTo,
}) => {
  let messageObj = {
    chatId: ticketInfo.chat_id,
    class: user.class,
    message: message,
    sender_id: user.id,
    sender_name: user.name,
    ticket_id: ticketInfo.id,
    attachments: [],
    reply_to: replyTo,
  };
  if (replyTo) {
    const cleanReplyTo = { ...replyTo };
    delete cleanReplyTo.reply_to;
    messageObj.reply_to = cleanReplyTo;
  }

  socket.emit("send_message", {
    messageObj,
    sender_id: user.id,
    chat_id: ticketInfo.chat_id,
    replyTo,
  });
};

export const sendNote = async ({
  socket,
  message,
  taggedUsers,
  taggedTickets,
  ticketInfo,
  user,
  replyTo,
}) => {
  let messageObj = {
    notesId: ticketInfo.notes_id,
    class: user.class,
    message: message,
    sender_id: user.id,
    sender_name: user.name,
    ticket_id: ticketInfo.id,
    attachments: [],
    reply_to: replyTo,
  };
  socket.emit("send_note", {
    messageObj,
    sender_id: user.id,
    taggedUsers: taggedUsers,
    taggedTickets: taggedTickets,
    notes_id: ticketInfo.notes_id,
    reply_to: replyTo,
  });
};

export const sendDeleteMessage = async ({
  socket,
  message,
  user,
  chatId,
  notesId,
}) => {
  let messageObj = {
    type: chatId ? "chats" : "notes",
    ticket_id: message.ticket_id,
    message_id: message.id,
    requester_id: user.id,
    conv_id: chatId ? chatId : notesId,
  };

  socket.emit("delete_message", {
    messageObj,
    sender_id: user.id,
    chat_id: chatId,
  });
};

export const sendEditMessage = async ({
  socket,
  message,
  new_message,
  user,
  chatId,
  notesId,
}) => {
  let messageObj = {
    type: chatId ? "chats" : "notes",
    ticket_id: message.ticket_id,
    message_id: message.id,
    conv_id: chatId ? chatId : notesId,
    new_message: new_message,
  };

  socket.emit("edit_message", {
    messageObj,
    sender_id: user.id,
    chat_id: chatId,
  });
};

export const onNewMessage = ({
  socket,
  setChat,
  setChatUsers,
  setTicketInformation,
  setGotNewMessages = null,
  chatId,
}) => {
  socket.off("new_message");
  socket.on("new_message", (newMessage) => {
    let message = newMessage.message || newMessage.messageObj || (newMessage.id ? newMessage : null);
    if (!message) return;

    const msgChatId = newMessage.chatId || newMessage.chat_id || message?.chatId || message?.chat_id || message?.chat_id;
    if (chatId && msgChatId && String(msgChatId) !== String(chatId)) return;

    setChat((prevMessages) => {
      if (prevMessages.some((msg) => String(msg.id) === String(message.id))) {
        return prevMessages;
      }
      return [...prevMessages, message].sort(
        (a, b) => (a.timestamp || 0) - (b.timestamp || 0),
      );
    });

    if (newMessage.user) {
      setChatUsers((prev) => ({
        ...prev,
        [newMessage.user.id]: newMessage.user,
      }));
    }

    if (newMessage.ticket) {
      setTicketInformation({ ticketData: newMessage.ticket });
    }

    if (setGotNewMessages) {
      setGotNewMessages();
    }
  });
};

export const onNewMessageUser = ({
  socket,
  setChat,
  setChatUsers,
  setTicketInformation,
  user = null,
  chatId = null,
  setGotNewMessages = null,
}) => {
  socket.off("new_message_user");
  socket.on("new_message_user", (newMessage) => {
    let message = newMessage.message || newMessage.messageObj || (newMessage.id ? newMessage : null);
    if (!message) return;

    const msgChatId = newMessage.chatId || newMessage.chat_id || message?.chatId || message?.chat_id;
    if (chatId && msgChatId && String(msgChatId) !== String(chatId)) return;

    setChat((prevMessages) => {
      if (prevMessages.some((msg) => String(msg.id) === String(message.id))) {
        return prevMessages;
      }
      return [...prevMessages, message].sort(
        (a, b) => (a.timestamp || 0) - (b.timestamp || 0),
      );
    });

    if (newMessage.user) {
      setChatUsers((prev) => ({
        ...prev,
        [newMessage.user.id]: newMessage.user,
      }));
    }

    if (newMessage.ticket) {
      setTicketInformation({ ticketData: newMessage.ticket });
    }

    if (setGotNewMessages) {
      setGotNewMessages();
    }
    if (user && chatId && user.class === "user") {
      sendMessagesRead({ socket: socket, userId: user.id, chatId: chatId });
    }
  });
};

export const onNewNote = ({
  socket,
  setNotes,
  setGotNewMessages = null,
  notesId,
}) => {
  socket.off("new_note");
  socket.on("new_note", (newMessage) => {
    let message = newMessage.message || newMessage.messageObj || (newMessage.id ? newMessage : null);
    if (!message) return;

    const msgNotesId = newMessage.notesId || newMessage.notes_id || message?.notesId || message?.notes_id;
    if (notesId && msgNotesId && String(msgNotesId) !== String(notesId)) return;

    setNotes((prevMessages) => {
      if (prevMessages.some((msg) => String(msg.id) === String(message.id))) {
        return prevMessages;
      }
      return [...prevMessages, message].sort(
        (a, b) => (a.timestamp || 0) - (b.timestamp || 0),
      );
    });

    if (setGotNewMessages) {
      setGotNewMessages();
    }
  });
};

export const onDeleteMessage = ({ socket, setChat, setChatUsers, chatId }) => {
  socket.off("deleted_message");
  socket.on("deleted_message", (pckg) => {
    const msgChatId = pckg?.chat_id || pckg?.chatId || pckg?.message?.chatId || pckg?.message?.chat_id || pckg?.deleted_message?.chatId || pckg?.deleted_message?.chat_id;
    if (chatId && msgChatId && String(msgChatId) !== String(chatId)) return;
    setChat((prevMessages) => {
      let cleansedMessages = prevMessages.filter((item) => {
        return String(item.id) !== String(pckg.deleted_message.id);
      });
      cleansedMessages = [...cleansedMessages, pckg.message].sort(
        (a, b) => (a.timestamp || 0) - (b.timestamp || 0),
      );
      return cleansedMessages;
    });
    if (pckg.user) {
      setChatUsers((prev) => ({ ...prev, [pckg.user.id]: pckg.user }));
    }
  });
};

export const onDeleteNote = ({ socket, setNotes, notesId }) => {
  socket.off("deleted_note");
  socket.on("deleted_note", (pckg) => {
    const msgNotesId = pckg?.notes_id || pckg?.notesId || pckg?.message?.notesId || pckg?.message?.notes_id || pckg?.deleted_message?.notesId || pckg?.deleted_message?.notes_id;
    if (notesId && msgNotesId && String(msgNotesId) !== String(notesId)) return;
    setNotes((prevMessages) => {
      let cleansedMessages = prevMessages.filter((item) => {
        return String(item.id) !== String(pckg.deleted_message.id);
      });
      cleansedMessages = [...cleansedMessages, pckg.message].sort(
        (a, b) => (a.timestamp || 0) - (b.timestamp || 0),
      );
      return cleansedMessages;
    });
  });
};

export const onEditMessage = ({
  socket,
  setChat,
  setChatUsers,
  userId = null,
  chatId = null,
}) => {
  socket.off("edited_message");
  socket.on("edited_message", (pckg) => {
    const msgChatId = pckg?.chat_id || pckg?.chatId || pckg?.message?.chatId || pckg?.message?.chat_id;
    if (chatId && msgChatId && String(msgChatId) !== String(chatId)) return;
    setChat((prevMessages) => {
      let cleansedMessages = prevMessages.filter((item) => {
        return String(item.id) !== String(pckg.message.id);
      });
      cleansedMessages = [...cleansedMessages, pckg.message].sort(
        (a, b) => (a.timestamp || 0) - (b.timestamp || 0),
      );
      return cleansedMessages;
    });
    if (pckg.user) {
      setChatUsers((prev) => ({ ...prev, [pckg.user.id]: pckg.user }));
    }

    if (userId && chatId) {
      sendMessagesRead({ socket: socket, userId: userId, chatId: chatId });
    }
  });
};

export const onEditNote = ({ socket, setNotes, notesId }) => {
  socket.off("edited_note");
  socket.on("edited_note", (pckg) => {
    const msgNotesId = pckg?.notes_id || pckg?.notesId || pckg?.message?.notesId || pckg?.message?.notes_id;
    if (notesId && msgNotesId && String(msgNotesId) !== String(notesId)) return;
    setNotes((prevMessages) => {
      let cleansedMessages = prevMessages.filter((item) => {
        return String(item.id) !== String(pckg.message.id);
      });
      cleansedMessages = [...cleansedMessages, pckg.message].sort(
        (a, b) => (a.timestamp || 0) - (b.timestamp || 0),
      );
      return cleansedMessages;
    });
  });
};

export const sendMessagesRead = ({ socket, userId, chatId }) => {
  socket.emit("messages_read", { sender_id: userId, chat_id: chatId });
};

export const onMessagesRead = ({ socket, setChat, chatId }) => {
  socket.off("mark_all_read");
  socket.on("mark_all_read", (pckg) => {
    const msgChatId = pckg?.chat_id || pckg?.chatId;
    if (chatId && msgChatId && String(msgChatId) !== String(chatId)) return;
    setChat((prevMessages) => {
      for (let i = 0; i < prevMessages.length; i++) {
        prevMessages[i].read = true;
      }
      return [...prevMessages];
    });
  });
};

export const uploadFiles = async (files) => {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append("files", files[i]);
  }

  const response = await fetch(BACKEND_URI + "/upload-files", {
    method: "POST",
    body: formData,
    mode: "cors",
  });

  return response.json(); // Assume the server returns file URLs
};

export const sendMessageWithFileLinks = async ({
  socket,
  message,
  files,
  ticketInfo,
  user,
  replyTo,
}) => {
  const fileUploadResponse = await uploadFiles(files);
  const fileUrls = fileUploadResponse.data.fileUrls;

  let messageObj = {
    chatId: ticketInfo.chat_id,
    class: user.class,
    message: message,
    sender_id: user.id,
    sender_name: user.name,
    ticket_id: ticketInfo.id,
    attachments: fileUrls,
    reply_to: replyTo,
  };
  if (replyTo) {
    const cleanReplyTo = { ...replyTo };
    delete cleanReplyTo.reply_to;
    messageObj.reply_to = cleanReplyTo;
  }
  socket.emit("send_message", {
    messageObj,
    sender_id: user.id,
    chat_id: ticketInfo.chat_id,
    reply_to: replyTo,
  });
};

export const sendNoteWithFileLinks = async ({
  socket,
  message,
  taggedUsers,
  taggedTickets,
  files,
  ticketInfo,
  user,
  replyTo,
}) => {
  const fileUploadResponse = await uploadFiles(files);
  const fileUrls = fileUploadResponse.data.fileUrls;

  let messageObj = {
    notesId: ticketInfo.notes_id,
    class: user.class,
    message: message,
    sender_id: user.id,
    sender_name: user.name,
    ticket_id: ticketInfo.id,
    attachments: fileUrls,
    reply_to: replyTo,
  };
  socket.emit("send_note", {
    messageObj,
    sender_id: user.id,
    taggedUsers: taggedUsers,
    taggedTickets: taggedTickets,
    notes_id: ticketInfo.notes_id,
    reply_to: replyTo,
  });
};

export const onTicketCompletedMessage = ({
  socket,
  setChat,
  setChatUsers,
  setTicketInformation,
  user = null,
  chatId = null,
}) => {
  socket.off("ticket_completed");
  socket.on("ticket_completed", (pckg) => {
    const msgChatId = pckg?.chat_id || pckg?.chatId || pckg?.message?.chatId || pckg?.message?.chat_id;
    if (chatId && String(msgChatId) !== String(chatId)) return;
    setChat((prevMessages) =>
      [...prevMessages, pckg.message].sort(
        (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
      ),
    );
    setTicketInformation({ ticketData: pckg.ticket });
    if (user && chatId && user.class === "user") {
      sendMessagesRead({ socket: socket, userId: user.id, chatId: chatId });
    }
  });
};

export const onTicketReopenedMessage = ({ socket, setChat, chatId }) => {
  socket.off("ticket_reopened");
  socket.on("ticket_reopened", (pckg) => {
    const msgChatId = pckg?.chat_id || pckg?.chatId || pckg?.message?.chatId || pckg?.message?.chat_id;
    if (chatId && String(msgChatId) !== String(chatId)) return;
    setChat((prevMessages) =>
      [...prevMessages, pckg.message].sort(
        (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
      ),
    );
  });
};

export const onCategoryChangeMessage = ({ socket, setChat, chatId }) => {
  socket.off("category_change_message");
  socket.on("category_change_message", (pckg) => {
    const msgChatId = pckg?.chat_id || pckg?.chatId || pckg?.message?.chatId || pckg?.message?.chat_id;
    if (chatId && String(msgChatId) !== String(chatId)) return;
    setChat((prevMessages) =>
      [...prevMessages, pckg.message].sort(
        (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
      ),
    );
  });
};

export const onBannedUserMessage = ({
  socket,
  setChat,
  setChatUsers,
  setAnonUser,
  chatId,
}) => {
  socket.off("banned_message");
  socket.on("banned_message", (pckg) => {
    const msgChatId = pckg?.chat_id || pckg?.chatId || pckg?.message?.chatId || pckg?.message?.chat_id;
    if (chatId && String(msgChatId) !== String(chatId)) return;
    setChat((prevMessages) =>
      [...prevMessages, pckg.message].sort(
        (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
      ),
    );
    setChatUsers((prev) => ({ ...prev, [pckg.user.id]: pckg.user }));
    setAnonUser((prev) => ({ ...prev, ...pckg.user }));
  });
};

export const onBannedWarning = ({ socket, openErrorModal }) => {
  socket.off("banned_warning");
  socket.on("banned_warning", (pckg) => {
    openErrorModal(pckg.error);
  });
};

export const onUsersOnline = ({ socket, setUsersOnline, roomId }) => {
  socket.off("users_in_room");
  socket.on("users_in_room", (pckg) => {
    if (roomId !== pckg.room_id) {
      return;
    }
    setUsersOnline((prev) => [...pckg.users]);
  });
};

export const onNewActiveChat = ({ socket, setTickets }) => {
  socket.off("new_active_chat");
  socket.on("new_active_chat", (pckg) => {
    setTickets((prevTickets) => {
      let temp = prevTickets.filter((ticket) => ticket.id !== pckg.ticket.id);
      pckg.ticket.gotMessageAt = Date.now();

      let sortedByStatus = {
        "NEW TICKET": [],
        "WAITING DEV": [],
        "ON HOLD": [],
        REPLIED: [],
        RESOLVED: [],
        CLOSED: [],
      };

      for (let i = 0; i < [...prevTickets, pckg.ticket].length; i++) {
        let ticket = [...prevTickets, pckg.ticket][i];
        sortedByStatus[ticket.status].push(ticket);
      }

      let sortedByUpdate = {};
      for (const [status, tickets] of Object.entries(sortedByStatus)) {
        sortedByUpdate[status] = tickets.sort(
          (b, a) => parseInt(a.lastUpdated) - parseInt(b.lastUpdated),
        );
      }

      let sorted = [];

      sorted.push(...sortedByUpdate["NEW TICKET"]);
      sorted.push(...sortedByUpdate["WAITING DEV"]);
      sorted.push(...sortedByUpdate["ON HOLD"]);
      sorted.push(...sortedByUpdate["REPLIED"]);
      sorted.push(...sortedByUpdate["RESOLVED"]);
      sorted.push(...sortedByUpdate["CLOSED"]);
      return sorted;
    });
  });
};

export const onRemoveActiveChat = ({ socket, setTickets }) => {
  socket.off("remove_active_chat");
  socket.on("remove_active_chat", (pckg) => {
    setTickets((prevTickets) =>
      prevTickets.filter(
        (ticket) => String(ticket.id) !== String(pckg.ticket_id),
      ),
    );
  });
};
